/**
 * Puente con el admin de Tienda Nube.
 *
 * *** Todo se importa desde la raíz de `@tiendanube/nexo`. *** La documentación oficial
 * dice `@tiendanube/nexo/helpers` y `@tiendanube/nexo/actions`, pero el paquete 1.3.1
 * publica únicamente `dist/index.js` y no declara `exports`: esos subpaths no existen.
 *
 * Advertencia de seguridad, verificada leyendo el bundle de 1.3.1: Nexo hace
 * `postMessage(mensaje, "*")` y su listener de `message` no valida `event.origin`. Por
 * lo tanto **nada de lo que devuelva este módulo sirve para decidir permisos**. En
 * particular, `getStoreInfo()` y `getUserAdminInfo()` son datos de presentación y nada
 * más: la identidad de la tienda la resuelve el backend verificando la firma del JWT.
 */

import { create, type NexoClient } from '@tiendanube/nexo';

const clientId = import.meta.env['VITE_TIENDANUBE_CLIENT_ID'] ?? '';

if (clientId === '' && import.meta.env.DEV) {
  console.warn(
    'Falta VITE_TIENDANUBE_CLIENT_ID. Copiá apps/admin/.env.example a apps/admin/.env.local.',
  );
}

export const nexo: NexoClient = create({
  clientId,
  log: import.meta.env.DEV,
});
